import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthService } from './services/auth.service';
import { SelectivePreloadingStrategy } from './core/services/selective-preloading.strategy';

export const routes: Routes = [
  {
    path: '',
    pathMatch:'full',
    loadComponent:() => import('./module/conncet-wallet/conncet-wallet.component').then((x)=> x.ConncetWalletComponent)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./module/dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [AuthService],
    data: { preload: true, priority: 1 },
  },
  {
    path: 'manage-category',
    loadChildren: () => import('./module/manage-category/manage-category.module').then((m) => m.ManageCategoryModule),
    canActivate: [AuthService],
    data: { preload: true, priority: 3 },
  },
  {
    path: 'manage-collection',
    loadChildren: () => import('./module/manage-collection/manage-collection.module').then((m) => m.ManageCollectionModule),
    canActivate: [AuthService],
    data: { preload: true, priority: 2 },
  },
  {
    path: 'manage-nft',
    loadChildren: () => import('./module/manage-nft/manage-nft.module').then((m) => m.ManageNftModule),
    canActivate: [AuthService],
    data: { preload: true, priority: 2 },
  },
  {
    path: 'manage-user',
    loadChildren: () => import('./module/manage-user/manage-user.module').then((m) => m.ManageUserModule),
    canActivate: [AuthService],
    data: { preload: true, priority: 2 },
  },
  {
    path: 'manage-delivery',
    loadChildren: () => import('./module/delivery/delivery.module').then((m) => m.DeliveryModule),
    canActivate: [AuthService],
    data: { preload: true, priority: 3 },
  },
  {
    path: 'royalty',
    loadChildren: () => import('./module/royalty/manage-royalty.module').then((x) => x.ManageRoyaltyModule),
    canActivate: [AuthService],
    data: { preload: true, priority: 3 },
  },
  {
    path: 'announcement-detail',
    loadChildren:() => import('./module/announcement-detail/announcement-detail.module').then((x)=> x.AnnouncementDetailModule),
    canActivate: [AuthService],
    data: { preload: true, priority: 4 },
  },
  {
    // Ops console for the asset deposit flow. Replaced the legacy /onboard requests page,
    // which has been removed.
    path: 'deposit-assets',
    loadChildren: () => import('./module/deposit-assets/deposit-assets.module').then(m => m.DepositAssetsModule),
    canActivate: [AuthService],
    data: { preload: true, priority: 4 },
  },
  {
    path: 'manage-loans',
    loadChildren: () => import('./module/manage-loan/manage-loan.module').then(m => m.ManageLoanModule),
    canActivate: [AuthService],
    data: { preload: true, priority: 3 },
  },
  {
    path: 'requested-withdrawal-wallets',
    loadChildren: () =>
      import('./module/requested-wallets/requested-wallets.module')
        .then(m => m.RequestedWalletsModule),
    canActivate: [AuthService],
    data: { preload: true, priority: 4 },
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, preloadingStrategy: SelectivePreloadingStrategy })],
  exports: [RouterModule],
})
/**
 * Export Class
 */
export class AppRoutingModule {}
